import { logout } from './redirect';

export function Logout() {
    logout();
}
